// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StockQuantity from "../../core/StockQuantity.res.js";
import * as Client from "@apollo/client";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockActivityReason from "../StockActivity/StockActivityReason.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

function get(values, field) {
  switch (field) {
    case "ShopId" :
      return values.shopId;
    case "DeviceId" :
      return values.deviceId;
    case "VariantId" :
      return values.variantId;
    case "VariantCapacityUnit" :
      return values.variantCapacityUnit;
    case "VariantCapacityPrecision" :
      return values.variantCapacityPrecision;
    case "Reason" :
      return values.reason;
    case "Quantity" :
      return values.quantity;
    case "Comment" :
      return values.comment;
  }
}

function set(values, field, value) {
  switch (field) {
    case "ShopId" :
      return {
        shopId: value,
        deviceId: values.deviceId,
        variantId: values.variantId,
        variantCapacityUnit: values.variantCapacityUnit,
        variantCapacityPrecision: values.variantCapacityPrecision,
        reason: values.reason,
        quantity: values.quantity,
        comment: values.comment
      };
    case "DeviceId" :
      return {
        shopId: values.shopId,
        deviceId: value,
        variantId: values.variantId,
        variantCapacityUnit: values.variantCapacityUnit,
        variantCapacityPrecision: values.variantCapacityPrecision,
        reason: values.reason,
        quantity: values.quantity,
        comment: values.comment
      };
    case "VariantId" :
      return {
        shopId: values.shopId,
        deviceId: values.deviceId,
        variantId: value,
        variantCapacityUnit: values.variantCapacityUnit,
        variantCapacityPrecision: values.variantCapacityPrecision,
        reason: values.reason,
        quantity: values.quantity,
        comment: values.comment
      };
    case "VariantCapacityUnit" :
      return {
        shopId: values.shopId,
        deviceId: values.deviceId,
        variantId: values.variantId,
        variantCapacityUnit: value,
        variantCapacityPrecision: values.variantCapacityPrecision,
        reason: values.reason,
        quantity: values.quantity,
        comment: values.comment
      };
    case "VariantCapacityPrecision" :
      return {
        shopId: values.shopId,
        deviceId: values.deviceId,
        variantId: values.variantId,
        variantCapacityUnit: values.variantCapacityUnit,
        variantCapacityPrecision: value,
        reason: values.reason,
        quantity: values.quantity,
        comment: values.comment
      };
    case "Reason" :
      return {
        shopId: values.shopId,
        deviceId: values.deviceId,
        variantId: values.variantId,
        variantCapacityUnit: values.variantCapacityUnit,
        variantCapacityPrecision: values.variantCapacityPrecision,
        reason: value,
        quantity: values.quantity,
        comment: values.comment
      };
    case "Quantity" :
      return {
        shopId: values.shopId,
        deviceId: values.deviceId,
        variantId: values.variantId,
        variantCapacityUnit: values.variantCapacityUnit,
        variantCapacityPrecision: values.variantCapacityPrecision,
        reason: values.reason,
        quantity: value,
        comment: values.comment
      };
    case "Comment" :
      return {
        shopId: values.shopId,
        deviceId: values.deviceId,
        variantId: values.variantId,
        variantCapacityUnit: values.variantCapacityUnit,
        variantCapacityPrecision: values.variantCapacityPrecision,
        reason: values.reason,
        quantity: values.quantity,
        comment: value
      };
  }
}

let CatalogVariantLossReportFormLenses_ = {
  get: get,
  set: set
};

let CatalogVariantLossReportFormLenses = {
  get: get,
  set: set
};

let CatalogVariantLossReportForm = Form.Make(CatalogVariantLossReportFormLenses);

let Raw = {};

let query = Client.gql(["mutation CreateStockActivity($input: InputCreateStockActivity!)  {\ncreateStockActivity(input: $input)  {\n__typename  \nid  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.createStockActivity;
  return {
    createStockActivity: {
      __typename: value$1.__typename,
      id: value$1.id
    }
  };
}

function serialize(value) {
  let value$1 = value.createStockActivity;
  let value$2 = value$1.id;
  let value$3 = value$1.__typename;
  let createStockActivity = {
    __typename: value$3,
    id: value$2
  };
  return {
    createStockActivity: createStockActivity
  };
}

function serializeInputObjectInputCreateStockActivity(inp) {
  let a = inp.kind;
  let a$1 = inp.comment;
  let a$2 = inp.reason;
  let a$3 = inp.stockKeepingUnit;
  let a$4 = inp.capacityUnit;
  let a$5 = inp.capacityPrecision;
  return {
    kind: a === "DELIVERY_RECEIPT" ? "DELIVERY_RECEIPT" : (
        a === "RESET" ? "RESET" : (
            a === "INCOMING_TRANSFER" ? "INCOMING_TRANSFER" : (
                a === "DELIVERY" ? "DELIVERY" : (
                    a === "REFUND" ? "REFUND" : (
                        a === "LOSS" ? "LOSS" : (
                            a === "CREDIT_MEMO" ? "CREDIT_MEMO" : (
                                a === "SALE" ? "SALE" : (
                                    a === "RECEPTION" ? "RECEPTION" : "OUTGOING_TRANSFER"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ),
    quantity: inp.quantity,
    comment: a$1 !== undefined ? a$1 : undefined,
    reason: a$2 !== undefined ? (
        a$2 === "DAMAGE" ? "DAMAGE" : (
            a$2 === "OUTDATED_DLUO" ? "OUTDATED_DLUO" : (
                a$2 === "SALE_BY_GLASS" ? "SALE_BY_GLASS" : (
                    a$2 === "THEFT" ? "THEFT" : (
                        a$2 === "TASTING" ? "TASTING" : (
                            a$2 === "LOSS" ? "LOSS" : (
                                a$2 === "OTHER" ? "OTHER" : (
                                    a$2 === "TRADE_IN_SUPPLIER" ? "TRADE_IN_SUPPLIER" : "CORKY"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ) : undefined,
    stockKeepingUnit: a$3 !== undefined ? a$3 : undefined,
    capacityUnit: a$4 !== undefined ? a$4 : undefined,
    capacityPrecision: a$5 !== undefined ? a$5 : undefined,
    variantId: inp.variantId,
    deviceId: inp.deviceId,
    shopId: inp.shopId
  };
}

function serializeVariables(inp) {
  return {
    input: serializeInputObjectInputCreateStockActivity(inp.input)
  };
}

function makeVariables(input, param) {
  return {
    input: input
  };
}

function makeInputObjectInputCreateStockActivity(kind, quantity, comment, reason, stockKeepingUnit, capacityUnit, capacityPrecision, variantId, deviceId, shopId, param) {
  return {
    kind: kind,
    quantity: quantity,
    comment: comment,
    reason: reason,
    stockKeepingUnit: stockKeepingUnit,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    variantId: variantId,
    deviceId: deviceId,
    shopId: shopId
  };
}

let CreateStockActivity_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateStockActivity: serializeInputObjectInputCreateStockActivity,
  makeVariables: makeVariables,
  makeInputObjectInputCreateStockActivity: makeInputObjectInputCreateStockActivity
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CreateStockActivity_useWithVariables = include.useWithVariables;

let CreateStockActivity = {
  CreateStockActivity_inner: CreateStockActivity_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateStockActivity: serializeInputObjectInputCreateStockActivity,
  makeVariables: makeVariables,
  makeInputObjectInputCreateStockActivity: makeInputObjectInputCreateStockActivity,
  use: use,
  useWithVariables: CreateStockActivity_useWithVariables
};

function useLossReportMutation(cku) {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let result = match[1];
  let mutate = match[0];
  let captureEvent = SessionTracker.useCaptureEvent();
  return React.useCallback((param, state) => {
    let shopId = state.shopId;
    if (shopId === undefined) {
      return Future.value({
        TAG: "Error",
        _0: I18n.t("Something went wrong")
      });
    }
    let deviceId = state.deviceId;
    if (deviceId !== undefined) {
      let variantId = state.variantId;
      if (variantId !== undefined) {
        let comment = state.comment;
        let capacityPrecision = state.variantCapacityPrecision;
        let input = makeInputObjectInputCreateStockActivity("LOSS", StockQuantity.toRawValue(capacityPrecision, state.quantity), comment.length > 0 ? comment : undefined, state.reason, undefined, state.variantCapacityUnit, capacityPrecision, variantId, deviceId, shopId, undefined);
        return Future.tapOk(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
          input: input
        })), undefined, param => Primitive_option.some(cku)), param => {
          captureEvent("catalog_variant_page_report_modal_click_save");
          let match = result.client;
          if (match !== undefined) {
            match.rescript_resetStore();
            return;
          }
        });
      }
    }
    return Future.value({
      TAG: "Error",
      _0: I18n.t("Something went wrong")
    });
  }, []);
}

let defaultFormValues = {
  shopId: undefined,
  deviceId: undefined,
  variantId: undefined,
  variantCapacityUnit: undefined,
  variantCapacityPrecision: undefined,
  reason: "LOSS",
  quantity: 0,
  comment: ""
};

function makeFormValues(shopId, shopsVariantStock, shops, param) {
  let maybeVariantStock = shopsVariantStock.find(shopVariantStock => {
    if (shopId !== undefined) {
      return shopId === shopVariantStock.shopId;
    } else {
      return false;
    }
  });
  if (maybeVariantStock === undefined) {
    return defaultFormValues;
  }
  let shopId$1 = maybeVariantStock.shopId;
  let maybeShop = shops.find(shop => shop.id === shopId$1);
  if (maybeShop !== undefined) {
    return {
      shopId: shopId$1,
      deviceId: maybeShop.activeWebDeviceId,
      variantId: maybeVariantStock.variantId,
      variantCapacityUnit: maybeVariantStock.capacityUnit,
      variantCapacityPrecision: maybeVariantStock.capacityPrecision,
      reason: "LOSS",
      quantity: 0,
      comment: ""
    };
  } else {
    return defaultFormValues;
  }
}

let schema = [
  {
    TAG: "Custom",
    _0: "ShopId",
    _1: param => {
      if (param.shopId !== undefined) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Missing shop")
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "Quantity",
    _1: param => {
      let quantity = param.quantity;
      if (param.variantCapacityPrecision !== undefined) {
        if (quantity > 0) {
          return {
            TAG: "Ok",
            _0: undefined
          };
        } else {
          return {
            TAG: "Error",
            _0: I18n.t("This value must be positive")
          };
        }
      } else if (quantity >= 1) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("This value must be positive")
        };
      }
    }
  }
];

function CatalogVariantLossReportModal(props) {
  let onRequestClose = props.onRequestClose;
  let shopsVariantStock = props.shopsVariantStock;
  let cku = props.cku;
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let onSubmit = useLossReportMutation(cku);
  let formInitialShopId = Stdlib_Option.map(activeShop, shop => shop.id);
  let formId = cku + Stdlib_Option.getOr(formInitialShopId, "");
  let formInitialValues = React.useMemo(() => makeFormValues(formInitialShopId, shopsVariantStock, shops, undefined), [
    formInitialShopId,
    shopsVariantStock,
    shops
  ]);
  let onSubmitSuccess = param => onRequestClose();
  let match = CatalogVariantLossReportForm.useFormPropState({
    id: formId,
    initialValues: formInitialValues,
    schema: schema,
    resetValuesAfterSubmission: true,
    onSubmitSuccess: onSubmitSuccess
  });
  let formDispatch = match[1];
  let formState = match[0];
  let formValuesShopId = formState.values.shopId;
  React.useEffect(() => {
    let formValues = makeFormValues(formValuesShopId, shopsVariantStock, shops, undefined);
    formDispatch({
      TAG: "FieldsValuesChanged",
      _0: values => ({
        shopId: values.shopId,
        deviceId: formValues.deviceId,
        variantId: formValues.variantId,
        variantCapacityUnit: formValues.variantCapacityUnit,
        variantCapacityPrecision: formValues.variantCapacityPrecision,
        reason: values.reason,
        quantity: values.quantity,
        comment: values.comment
      })
    });
  }, [formValuesShopId]);
  let items = StockActivityReason.values.map(reason => ({
    TAG: "Option",
    key: StockActivityReason.toString(reason),
    label: StockActivityReason.toLabel(reason),
    value: reason
  }));
  let unit = formState.values.variantCapacityUnit;
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(CatalogVariantLossReportForm.Core.Provider.make, {
      children: JsxRuntime.jsxs(Box.make, {
        children: [
          JsxRuntime.jsxs(Stack.make, {
            children: [
              Stdlib_Option.isNone(activeShop) ? JsxRuntime.jsx(CatalogVariantLossReportForm.InputSelect.make, {
                  field: "ShopId",
                  label: I18n.t("Shop"),
                  placeholder: I18n.t("Select a shop"),
                  sections: [{
                      items: shopsVariantStock.map(param => {
                        let shopId = param.shopId;
                        return {
                          TAG: "Option",
                          key: shopId,
                          label: param.shopName,
                          value: shopId
                        };
                      })
                    }]
                }) : null,
              JsxRuntime.jsx(CatalogVariantLossReportForm.InputSelect.make, {
                field: "Reason",
                label: I18n.t("Loss reason"),
                sections: [{
                    items: items
                  }]
              }),
              JsxRuntime.jsx(CatalogVariantLossReportForm.InputNumber.make, {
                field: "Quantity",
                label: I18n.t("Quantity"),
                appender: unit !== undefined ? ({
                    TAG: "Custom",
                    _0: unit
                  }) : undefined,
                minValue: 0,
                precision: Stdlib_Option.getOr(formState.values.variantCapacityPrecision, 0)
              }),
              JsxRuntime.jsx(CatalogVariantLossReportForm.InputTextArea.make, {
                field: "Comment",
                label: I18n.t("Comment")
              })
            ],
            space: "normal"
          }),
          JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsxs(Inline.make, {
              children: [
                JsxRuntime.jsx(Button.make, {
                  label: I18n.t("Cancel"),
                  onPress: () => onRequestClose()
                }),
                JsxRuntime.jsx(CatalogVariantLossReportForm.SubmitButton.make, {
                  label: I18n.t("Save"),
                  tone: "success",
                  onSubmit: onSubmit
                })
              ],
              space: "normal",
              align: "end"
            }),
            spaceY: "xlarge"
          })
        ],
        spaceX: "xlarge",
        spaceTop: "xlarge"
      }),
      propState: [
        formState,
        formDispatch
      ]
    }),
    opened: props.opened,
    title: I18n.t("Report a loss"),
    hideFooter: true,
    onRequestClose: onRequestClose
  });
}

let make = React.memo(CatalogVariantLossReportModal, (oldProps, newProps) => {
  if (oldProps.cku === newProps.cku && oldProps.shopsVariantStock === newProps.shopsVariantStock) {
    return oldProps.opened === newProps.opened;
  } else {
    return false;
  }
});

let Config;

export {
  CatalogVariantLossReportFormLenses_,
  CatalogVariantLossReportFormLenses,
  CatalogVariantLossReportForm,
  CreateStockActivity,
  useLossReportMutation,
  Config,
  defaultFormValues,
  makeFormValues,
  schema,
  make,
}
/* CatalogVariantLossReportForm Not a pure module */
